import React, { useContext, useState } from 'react';
import { Autocomplete, Field, Mapper, Modal, Text, useIsMobileResolution } from '@philips-internal/oswald-ui-components';
import { ModalButtonType, ModalType, ThemeTonalRange } from '@philips-internal/oswald-ui-constants';
import { AuthenticationService, ConfigurationService, HistoryService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { FoundationApplicationContext } from '../../context/index.js';
import { foundationContext } from '../../index.js';
import { requestInformation } from '../../util/index.js';
import { FoundationLoader } from '../index.js';
function InformationField(props) {
    const { data, displayEntry, enabled, field, fieldData, label, onChange } = props;
    // TODO: would be nice if the Autocomplete component accepted a generic type.
    const castedData = data;
    return (React.createElement(Field, { alwaysShowLabel: true, className: "c-spotlight__edit-information-field", data: fieldData, entry: field, label: label, onChange: onChange, uuid: "fake-uuid", width: 12 },
        React.createElement(Autocomplete, { data: castedData, enabled: enabled, entry: displayEntry, localData: true, minSearchLength: 0, queryKey: displayEntry, title: label, uuid: "fake-uuid" },
            React.createElement(Mapper, { map: { value: displayEntry } },
                React.createElement(Text, null)))));
}
function EditInformation(props) {
    const { establishmentExpression, modalTitle, onClose, profileExpression, sectorExpression, submitExpression, } = props;
    const applicationContext = useContext(FoundationApplicationContext);
    const [establishment, setEstablishment] = useState(foundationContext.getEstablishment());
    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState(foundationContext.getProfile());
    const [sector, setSector] = useState(foundationContext.getSector());
    const isMobileResolution = useIsMobileResolution();
    const onChange = () => {
        setLoading(true);
        const abortController = new AbortController();
        const parameters = {
            'ext_establishment_id': establishment?.id,
            'ext_profile_id': profile?.id,
            'ext_sector_id': sector?.id,
        };
        void AuthenticationService.requestRefreshToken(parameters).then(() => {
            void requestInformation(abortController, true).then(() => {
                setLoading(false);
                onClose();
                applicationContext.closeModules();
                const { routes } = ConfigurationService.getAuthenticationConfiguration() || {};
                if (routes?.home) {
                    HistoryService.push(routes.home);
                }
            });
        });
    };
    const onChangeEstablishment = (establishment) => {
        setEstablishment(establishment);
    };
    const onChangeProfile = (profile) => {
        setProfile(profile);
    };
    const onChangeSector = (sector) => {
        setSector(sector);
    };
    const dockButtons = [
        {
            action: onChange,
            title: MessageService.translate(submitExpression),
            type: ModalButtonType.SUCCESS,
        },
    ];
    if (loading) {
        return React.createElement(FoundationLoader, null);
    }
    const form = {
        establishment,
        profile,
        sector,
    };
    return (React.createElement(Modal, { dockButtons: dockButtons, onClose: onClose, theme: ThemeTonalRange.ULTRA_LIGHT, title: modalTitle, type: isMobileResolution ? ModalType.FULLSCREEN : ModalType.DEFAULT },
        React.createElement("div", { className: "c-spotlight__edit-information" },
            React.createElement("div", { className: "c-spotlight__edit-information-fields" },
                React.createElement(InformationField, { data: foundationContext.getAvailableEstablishments() || [], displayEntry: "tradingName", enabled: foundationContext.canEditEstablishment(), field: "establishment", fieldData: form, label: MessageService.translate(establishmentExpression), onChange: (event) => onChangeEstablishment(event.value) }),
                React.createElement(InformationField, { data: foundationContext.getAvailableSectors() || [], displayEntry: "name", enabled: foundationContext.canEditSector(), field: "sector", fieldData: form, label: MessageService.translate(sectorExpression), onChange: (event) => onChangeSector(event.value) }),
                React.createElement(InformationField, { data: foundationContext.getAvailableProfiles() || [], displayEntry: "name", enabled: foundationContext.canEditProfile(), field: "profile", fieldData: form, label: MessageService.translate(profileExpression), onChange: (event) => onChangeProfile(event.value) })))));
}
export { EditInformation, };
//# sourceMappingURL=edit-information.js.map